export default __webpack_public_path__ + "static/media/super-rare.50f67685.svg";